import {Component, Input} from '@angular/core'
import { NuclearObservable } from '../nuclear-observable'
import { BaseComponent } from './base.component'
import { SessionActions } from '../actions/session-actions'
import {aboutComplete, topicsComplete, planComplete} from '../logic/customer-signup'
import {Customer, Account} from '../types'
import {customerGetters} from '../stores/customer-store'

@Component({
  selector: 'nc-nav',
  styles: [`
    :host { display: block; }
  `],
  template: `
    <div class="container-fluid huge-top-buffer">
      <div class="logo-and-nav">
        <div class="row">
          <div class="col">
            <a class="navbar-brand no-medium-or-smaller logo-icon float-left" href="/">
              <img alt="Sign in" src="/assets/verblio-logo-horizontal-light.png" height="40">
            </a>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <ul class="breadcrumbs list-unstyled mt-lg-5">
              <ng-template [ngIf]="!customer">
                <li class="cursor-pointer">
                  <h6>Already have an account?</h6>
                  <div><a class="btn btn-outline-light" href="/d/users/sign_in" role="button">Sign in</a></div>
                </li>
                <hr />
                <li>
                  <h6>Need help?</h6>
                  <div><a class="btn btn-outline-light ap-open" href="javascript: window.Intercom('show');" role="button">Chat with us</a></div>
                </li>
              </ng-template>
              <ng-template [ngIf]="customer">
                <li class="cursor-pointer" [routerLink]="[customer.id, 'about']" routerLinkActive="active">
                  <div class="breadcrumb-icon fas fa-comment no-medium-or-larger"></div>
                  <h4>
                    <span class="title font-weight-300">About</span>
                    <span *ngIf="aboutComplete()" class="fas fa-check small-left-buffer"></span>
                  </h4>
                </li>
                <li class="cursor-pointer" [routerLink]="[customer.id, customer.multipass? 'multipass-plan' : 'plan']" routerLinkActive="active">
                  <div class="breadcrumb-icon fas fa-check-square no-medium-or-larger"></div>
                  <h4>
                    <span class="title font-weight-300">Plan/Pricing</span>
                    <span *ngIf="planComplete()" class="fas fa-check small-left-buffer"></span>
                  </h4>
                </li>
                <li class="cursor-pointer" [routerLink]="[customer.id, 'payment']" routerLinkActive="active">
                  <div class="breadcrumb-icon fas fa-credit-card no-medium-or-larger"></div>
                  <h4>
                    <span class="title font-weight-300">Activate</span>
                    <span *ngIf="activationComplete()" class="fas fa-check small-left-buffer"></span>
                  </h4>
                </li>
                <li class="huge-top-buffer cursor-pointer" (click)="signOut()">
                  <div class="breadcrumb-icon fas fa-sign-out-alt no-medium-or-larger"></div>
                  <h4 class="font-weight-300">Sign out</h4>
                </li>
                <hr class="huge-top-buffer huge-bottom-buffer d-none d-md-inline-block" />
                <li class="hidden-sm hidden-xs d-none d-md-inline-block">
                  <p>Need help?</p>
                  <div><a class="btn btn-outline-light text-white ap-open" href="javascript: window.Intercom('show');" role="button">Chat with us</a></div>
                </li>
              </ng-template>
            </ul>
          </div>
        </div>
      </div>
    </div>
  `
})
export class NcNav extends BaseComponent {
  @Input() customer: Customer;
  private account: Account;

  constructor(private sessionActions: SessionActions) {
    super()

    const accountObs = NuclearObservable.from<Account>(customerGetters.account, { toJS: true }).subscribe(a => this.account = a)
    this.observers.push(accountObs)
  }

  signOut(): void {
    this.sessionActions.signOut()
  }

  aboutComplete(): boolean {
    return aboutComplete(this.customer)
  }

  topicsComplete(): boolean {
    return topicsComplete(this.customer)
  }

  planComplete(): boolean {
    return planComplete(this.customer)
  }

  activationComplete(): boolean {
    return this.account && this.account.fullySetUp
  }
}
